import { render, staticRenderFns } from "./XInputGroupRoles.vue?vue&type=template&id=0a8b28d6"
import script from "./XInputGroupRoles.vue?vue&type=script&lang=js"
export * from "./XInputGroupRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports